import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { transformDraftToVariantVersion } from "./transformers";
import { TiVoAppVariantDraft } from "./types";

export const useVariantDraft = (id?: string) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["variantDraft", id],
    queryFn: (): ApiResponse<TiVoAppVariantDraft> =>
      dispatch(
        apiThatThrows.getTiVoVariantDraft.action({
          params: { id },
        })
      ),
    enabled: Boolean(id), // don't run if no id
    select: (results) => ({
      meta: results.meta,
      results: transformDraftToVariantVersion(results.results),
    }),
  });
};
